export default __webpack_public_path__ + "static/media/bitgert-icon.22c6049d.png";